(() => {
  const page = document;
  const money = (cents, currency) => new Intl.NumberFormat(undefined, {
    style: 'currency', currency: currency || 'USD'
  }).format(Number(cents || 0) / 100);

  function initPage() {
    const roots = [...page.querySelectorAll('[data-silver-scrub-root]')];
    if (!roots.length) return;
    const currency = roots[0].dataset.currency || 'USD';
    const bundles = [...page.querySelectorAll('[data-ss-bundle]')];
    const priceTargets = [...page.querySelectorAll('[data-ss-price]')];
    const packTargets = [...page.querySelectorAll('[data-ss-pack]')];
    const shipTargets = [...page.querySelectorAll('[data-ss-shipping]')];
    let selected = bundles.find(button => button.classList.contains('is-selected')) || bundles[0];

    function selectBundle(button) {
      if (!button) return;
      selected = button;
      bundles.forEach(item => {
        const active = item === button;
        item.classList.toggle('is-selected', active);
        item.setAttribute('aria-checked', String(active));
      });
      const label = button.dataset.label || button.dataset.pack || 'Bundle';
      const shipping = button.dataset.shipping || '';
      const formattedPrice = money(button.dataset.priceCents, currency);
      priceTargets.forEach(target => { target.textContent = formattedPrice; });
      packTargets.forEach(target => { target.textContent = label; });
      shipTargets.forEach(target => { target.textContent = shipping; });
      page.querySelectorAll('[data-ss-buy-note]').forEach(target => { target.textContent = `${label} selected`; });
    }

    bundles.forEach(button => {
      if (button.dataset.ssReady) return;
      button.dataset.ssReady = 'true';
      button.addEventListener('click', () => selectBundle(button));
    });
    selectBundle(selected);

    page.querySelectorAll('[data-ss-select-pack]').forEach(button => {
      if (button.dataset.ssReady) return;
      button.dataset.ssReady = 'true';
      button.addEventListener('click', () => {
        const pack = button.dataset.ssSelectPack;
        selectBundle(bundles.find(item => item.dataset.pack === pack));
        page.querySelector('[data-ss-shop]')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    page.querySelectorAll('[data-ss-scroll-shop]').forEach(button => {
      if (button.dataset.ssReady) return;
      button.dataset.ssReady = 'true';
      button.addEventListener('click', () => page.querySelector('[data-ss-shop]')?.scrollIntoView({ behavior: 'smooth', block: 'start' }));
    });

    page.querySelectorAll('[data-ss-thumb]').forEach(button => {
      if (button.dataset.ssReady) return;
      button.dataset.ssReady = 'true';
      button.addEventListener('click', () => {
        const main = page.querySelector('[data-ss-main-image]');
        page.querySelectorAll('[data-ss-thumb]').forEach(item => item.classList.toggle('is-active', item === button));
        if (!main) return;
        main.style.opacity = '0';
        window.setTimeout(() => {
          main.src = button.dataset.image;
          main.removeAttribute('srcset');
          main.alt = button.dataset.alt || main.alt;
          main.style.opacity = '1';
        }, 140);
      });
    });

    page.querySelectorAll('[data-ss-atc]').forEach(button => {
      if (button.dataset.ssReady) return;
      button.dataset.ssReady = 'true';
      button.addEventListener('click', async () => {
        const variantId = selected?.dataset.variantId;
        const status = page.querySelector('[data-ss-form-status]');
        if (!variantId) { if (status) status.textContent = 'This bundle is temporarily unavailable.'; return; }
        const buttons = [...page.querySelectorAll('[data-ss-atc]')];
        const oldLabels = buttons.map(item => item.innerHTML);
        buttons.forEach(item => { item.disabled = true; item.textContent = 'ADDING…'; });
        if (status) status.textContent = '';
        try {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
          });
          if (!response.ok) throw new Error('Cart request failed');
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          buttons.forEach(item => { item.textContent = '✓ ADDED TO CART'; });
          window.setTimeout(() => { window.location.href = (window.Shopify?.routes?.root || '/') + 'cart'; }, 450);
        } catch (error) {
          buttons.forEach((item, index) => { item.innerHTML = oldLabels[index]; item.disabled = false; });
          if (status) status.textContent = 'Could not add this bundle. Please try again.';
        }
      });
    });

    page.querySelectorAll('[data-ss-faq]').forEach(button => {
      if (button.dataset.ssReady) return;
      button.dataset.ssReady = 'true';
      button.addEventListener('click', () => {
        const item = button.closest('.ss-faq-item');
        const open = item.classList.toggle('is-open');
        button.setAttribute('aria-expanded', String(open));
      });
    });

    page.querySelectorAll('[data-ss-offer]').forEach(card => {
      if (card.dataset.ssReady) return;
      card.dataset.ssReady = 'true';
      const minutes = card.querySelector('[data-ss-minutes]');
      const seconds = card.querySelector('[data-ss-seconds]');
      const duration = Number(card.dataset.duration || 15) * 60 * 1000;
      const storageKey = `silverScrubOffer-${card.dataset.offerId || 'main'}`;
      let deadline;
      try {
        deadline = Number(sessionStorage.getItem(storageKey));
        if (!Number.isFinite(deadline) || deadline <= Date.now()) {
          deadline = Date.now() + duration;
          sessionStorage.setItem(storageKey, String(deadline));
        }
      } catch (error) { deadline = Date.now() + duration; }
      card.classList.remove('is-ended');
      const tick = () => {
        const remaining = Math.max(0, deadline - Date.now());
        const total = Math.floor(remaining / 1000);
        if (minutes) minutes.textContent = String(Math.floor(total / 60)).padStart(2, '0');
        if (seconds) seconds.textContent = String(total % 60).padStart(2, '0');
        if (!remaining) card.classList.add('is-ended');
      };
      tick();
      card._ssTimer = window.setInterval(tick, 1000);
    });

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const designMode = Boolean(window.Shopify && window.Shopify.designMode);
    const elements = page.querySelectorAll('.silver-scrub .ss-reveal,.silver-scrub .ss-left,.silver-scrub .ss-right,.silver-scrub .ss-scale');
    if (reduceMotion || designMode || !('IntersectionObserver' in window)) {
      elements.forEach(element => element.classList.add('is-visible'));
    } else {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: .11, rootMargin: '0px 0px -6% 0px' });
      elements.forEach(element => {
        if (element.dataset.ssObserved) return;
        element.dataset.ssObserved = 'true';
        const delay = Number(element.dataset.delay || 0);
        if (delay) element.style.transitionDelay = `${delay}ms`;
        observer.observe(element);
      });
    }
  }

  if (!window.__silverScrubListenerReady) {
    window.__silverScrubListenerReady = true;
    document.addEventListener('shopify:section:load', initPage);
    document.addEventListener('shopify:block:select', initPage);
  }
  initPage();
})();
